import { useMemo } from 'react'
import type { IntlShape } from 'react-intl'
import { useIntl } from 'react-intl'
import type { MultiCartReviewSnackbarLabels } from './multiCartReviewMachine'

export function buildMultiCartReviewLabels(intl: IntlShape): MultiCartReviewSnackbarLabels {
  return {
    cartUpdated: intl.formatMessage({
      id: 'sr0tXikiOSGLKoJLs2eR',
      defaultMessage: 'Cart has been updated!',
      description: 'Success snackbar message shown after a cart name is updated',
    }),
    cartUpdateFailed: intl.formatMessage({
      id: 'zcyauPywU-F32FqpkrDK',
      defaultMessage: 'Failed to update cart',
      description: 'Error snackbar message shown when a cart name update fails',
    }),
    cartDeleted: intl.formatMessage({
      id: 'MxjZj4vjFLDTBOjeO3kF',
      defaultMessage: 'Cart has been deleted!',
      description: 'Success snackbar message shown after a cart is deleted',
    }),
    cartDeleteFailed: intl.formatMessage({
      id: '2z3sMthaplnBttNhGWZX',
      defaultMessage: 'Failed to delete cart',
      description: 'Error snackbar message shown when a cart deletion fails',
    }),
    deleteAllItemsFailed: intl.formatMessage({
      id: 'OCptilnzb5rjRgDZxa1D',
      defaultMessage: 'Failed to delete all items from cart',
      description: 'Error snackbar message shown when deleting all cart items fails',
    }),
    saveForLaterFailed: intl.formatMessage({
      id: 'TOAjcdgaegMlOBVhNZJG',
      defaultMessage: 'Failed to update the cart',
      description: 'Error snackbar message shown when saving items for later fails',
    }),
    allItemsSavedForLater: intl.formatMessage({
      id: 'C8QeyQJhOuocx4embbPq',
      defaultMessage: 'All items have been saved for later',
      description: 'Success snackbar message shown when all items are saved for later',
    }),
    itemSavedForLater: intl.formatMessage({
      id: 'pcNNjiMMqPLLTS_Fpbls',
      defaultMessage: 'Item has been saved for later',
      description: 'Success snackbar message shown when a single item is saved for later',
    }),
    allItemsAddedBack: intl.formatMessage({
      id: 'T1vWzPJThjJzGRBA1PTI',
      defaultMessage: 'All items have been added back to the cart',
      description: 'Success snackbar message shown when all saved items are moved back to cart',
    }),
    itemAddedBack: intl.formatMessage({
      id: 'SXmmw-2-OW_k7OHrsVm3',
      defaultMessage: 'Item has been added back to the cart',
      description: 'Success snackbar message shown when a single saved item is moved back to cart',
    }),
  }
}

function useMultiCartReviewLabels(): MultiCartReviewSnackbarLabels {
  const intl = useIntl()
  return useMemo(() => buildMultiCartReviewLabels(intl), [intl])
}

export default useMultiCartReviewLabels
